// for unassigment of employee
export const RESET_DELETE_CUSTOMER_BANK_INFO = "reset_delete_customer_bank_info";
export const DELETE_CUSTOMER_BANK_INFO = "delete_customer_bank_info";
export const DELETE_CUSTOMER_BANK_INFO_SUCCESS = "delete_customer_bank_info_success";
export const DELETE_CUSTOMER_BANK_INFO_FAILURE = "delete_customer_bank_info_failure";
